import {logging} from "@/utils/utils";

export default function subscriptionSkuApis($apiInstance, $store) {
    return {
        // 구독 상품 목록 조회
        getSubscriptionProducts: async (params, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                // 필수 파라미터 확인 및 기본값 설정
                const searchParams = {
                    page: params.page || 1,
                    limit: params.limit || 10,
                };
                
                // 추가 조건이 있는 경우에만 파라미터 추가
                if (params.productGroup) searchParams.productGroup = params.productGroup;
                if (params.productName) searchParams.productName = params.productName;
                if (params.isActive !== undefined) searchParams.isActive = params.isActive;
                
                // 디버깅용 로그
                console.log('구독 상품 목록 조회 요청 파라미터:', searchParams);
                
                const response = await $apiInstance.post('/subscription-skus', searchParams);
                logging().exceptProd('구독 상품 목록 조회==>', response.data);
                success(response);
            } catch (error) {
                console.error('구독 상품 목록 조회 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 구독 상품 상세 조회
        getSubscriptionProductDetail: async (productId, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.get(`/subscription-skus/${productId}`);
                logging().exceptProd('구독 상품 상세 조회==>', response.data);
                success(response);
            } catch (error) {
                console.error('구독 상품 상세 조회 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 구독 상품 생성
        createSubscriptionProduct: async (productData, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.post('/subscription-skus/create', productData);
                logging().exceptProd('구독 상품 생성==>', response.data);
                success(response);
            } catch (error) {
                console.error('구독 상품 생성 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 구독 상품 수정
        updateSubscriptionProduct: async (productId, productData, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.put(`/subscription-skus/${productId}`, productData);
                logging().exceptProd('구독 상품 수정==>', response.data);
                success(response);
            } catch (error) {
                console.error('구독 상품 수정 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 구독 상품 삭제
        deleteSubscriptionProduct: async (productId, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.delete(`/subscription-skus/${productId}`);
                logging().exceptProd('구독 상품 삭제==>', response.data);
                success(response);
            } catch (error) {
                console.error('구독 상품 삭제 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 그룹별 구독 상품 목록 조회
        getSubscriptionProductsByGroup: async (groupName, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.get(`/subscription-skus/groups/${groupName}`);
                logging().exceptProd('그룹별 구독 상품 목록 조회==>', response.data);
                success(response);
            } catch (error) {
                console.error('그룹별 구독 상품 목록 조회 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 할인율 계산 기준 업데이트
        updateDiscountCalculationBase: async (productId, isBasedOnListPrice, success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.put(`/subscription-skus/${productId}/discount-base?isBasedOnListPrice=${isBasedOnListPrice}`);
                logging().exceptProd('할인율 계산 기준 업데이트==>', response.data);
                success(response);
            } catch (error) {
                console.error('할인율 계산 기준 업데이트 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },
        
        // 정가 기준 할인 SKU 조회
        getListPriceBasedSku: async (success, fail) => {
            $store.commit('setIsLoading', true);

            try {
                const response = await $apiInstance.get('/subscription-skus/discount-base/reference-sku');
                logging().exceptProd('정가 기준 할인 SKU 조회==>', response.data);
                success(response);
            } catch (error) {
                console.error('정가 기준 할인 SKU 조회 API 오류:', error);
                fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        }
    }
} 